import {NgModule, Component, OnInit, Pipe, ViewChild, ViewChildren, AfterViewChecked, AfterContentInit, AfterViewInit, QueryList, Query} from '@angular/core';
import {Input, Output,EventEmitter} from '@angular/core';
import {BrowserModule}   from '@angular/platform-browser';
import {DialogModule,ButtonModule, GMapModule} from 'primeng/primeng';
import { CustomGMapModule } from "./gmap.component";

import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../translate/translate.module.pipe"; // ADD THIS
declare var google: any;

@Component({
    selector:'location-dialog',
    templateUrl:'./policyresource.dialog.component.html'
})
export class LocationDialogComponent{
    @Input() gmap_show: boolean;
    @Input() title:string;
    @Input() width: any;
    @Input() gps_show_type : string;
    @Input() overlay_data : any;
    @Input() action_clear : boolean;
    @Input() location_show_type : string;
    @Input() location_show : boolean;

    @Output() onSubmit:EventEmitter<any> = new EventEmitter();
    @Output() onCancel:EventEmitter<any> = new EventEmitter();
    @Output() visibleChange:EventEmitter<any> = new EventEmitter();
    @Output() sendLocationInfo = new EventEmitter();

    @Output() zoneGps = new EventEmitter();
    _show_type : string = this.gps_show_type;
    _overlay_data : any;

    _visible: boolean;
    private logger : Logger = new Logger();
    
    @Input() get visible(): boolean {
        this._show_type = this.gps_show_type;
        this._overlay_data = this.overlay_data;
        return this._visible;
    }

    set visible(val:boolean) {
        this._visible = val;
        this.visibleChange.emit(val);
    }
    private onYes():void{
        //this.visible = false;
        //this.gmap_show = false;
        this.onSubmit.emit({originalEvent: event});
    }
    private onNo():void{
        this.visible = false;
        this.gmap_show = false;
        this.logger.debug("No ->", this.gmap_show);
        this.onCancel.emit({originalEvent: event});
    }

    create_gps_data(event) {
      this.logger.debug("create_event_ :", event)
      this.zoneGps.emit(event);
    }

    location_data(event) {
      this.logger.debug("event :", event);
      this.sendLocationInfo.emit(event);
    }

    onlyNumber(event) {
      if (event.key == "Escape") {
        this.action_clear = true;
        this.gmap_show = false;
        this.location_show = false;
      }
      else {
        this.action_clear = false;
        this.gmap_show = false;
        this.location_show =false;
      }

    }
}


@NgModule({
    imports:[DialogModule,BrowserModule,ButtonModule, GMapModule, CustomGMapModule, TranslatePipeMoudle],
    declarations:[LocationDialogComponent],
    exports:[LocationDialogComponent],
    providers:[]
})
export class LocationDialogModule{

}



// WEBPACK FOOTER //
// ./src/app/component/policyresource.dialog.component.ts